module.exports = __webpack_public_path__ + "static/media/arrow-white.83543be8.svg";